"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OffWithTheirHeadAbilityHandler = exports.OffWithTheirHeadActorAbilityFactory = exports.OffWithTheirHeadAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Registries_1 = require("../../core/state/Registries");
class OffWithTheirHeadAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.OffWithTheirHead;
        this.__typeName = "OffWithTheirHead";
    }
}
exports.OffWithTheirHeadAbilityArgs = OffWithTheirHeadAbilityArgs;
let OffWithTheirHeadActorAbilityFactory = class OffWithTheirHeadActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("OffWithTheirHead", "OneEnemies", 3);
    }
};
OffWithTheirHeadActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("OffWithTheirHead")
], OffWithTheirHeadActorAbilityFactory);
exports.OffWithTheirHeadActorAbilityFactory = OffWithTheirHeadActorAbilityFactory;
let OffWithTheirHeadAbilityHandler = class OffWithTheirHeadAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 100)
            ],
            onHit: sequence => {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(2),
                    effect: new core_1.VulnerabilityEffectArgs(3)
                });
            }
        });
    }
};
OffWithTheirHeadAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.OffWithTheirHead)
], OffWithTheirHeadAbilityHandler);
exports.OffWithTheirHeadAbilityHandler = OffWithTheirHeadAbilityHandler;
